import { IModuleProps } from '../../core/utils/modules.tsx';

import routes from './routes.tsx';

export default {
    name: 'invoices',
    routes,
} as IModuleProps;
